import { Component, OnInit } from '@angular/core';
import { WebService } from '../services/web/web.service'; 
import { TreeNode, TreeModel, TREE_ACTIONS, KEYS, IActionMapping, ITreeOptions } from 'angular-tree-component';
import {SocketService} from '../services/socket/socket.service';

@Component({
  selector: 'app-assignmenu',
  templateUrl: './assignmenu.component.html',
  styleUrls: ['./assignmenu.component.css']
})
export class AssignmenuComponent implements OnInit {
 model: any = {};
 appnames;
 selectedappname;
 selecteduser;
 appusers:any;
 appMenus:any;
 parentMenu =[];
 childMenu=[];
 nodes:any=[];

 /*nodes = [
    {
      name: 'root1',
    },
    {
      name: 'root2',
      children: [
        { name: 'child1' },
        { name: 'child2', children: [
          { name: 'grandchild1' },
          { name: 'grandchild2' }
        ] }
      ]
    },
    {
      name: 'asyncroot',
      hasChildren: true
    }
  ];*/

 actionMapping: IActionMapping = {
      mouse: {
        click: (tree, node) => this.check(node, !node.data.checked)
      }
  };

  options: ITreeOptions = {
      displayField: 'menuname',
    //  useCheckbox: true,
    //  idField: '_id',
      hasChildrenField: 'children',
      actionMapping: this.actionMapping
 
    };
 
  constructor(private httpService:WebService,private socketService:SocketService) {

  	this.httpService.getMethod('/menuroute/getappname').then(appdata=>{
  			this.appnames = appdata.json();
  			this.appnames = this.appnames.appnames;
  			console.log(this.appnames);
  		}).catch(err=>{
  			console.log(err);
  		})
  		
      var reviewObj={"appname":'cochin'}

      this.socketService.sendMessage(reviewObj)


      this.socketService.getMessages().subscribe((data)=>{
                 console.log(data)


    })
   }

  ngOnInit() { 
  }

  assigMenu(){
    /*console.log(this.model)
    console.log(this.parentMenu);
    console.log(this.childMenu);*/
     var user ={
        userId: this.model.selecteduser,//this.selectedUser['_id'],
        parentMenuId:this.parentMenu,
        childMenuId:this.childMenu,
        appname :this.model.selectedappname,
        assignBy:"Insuide"
      }
     // console.log("====call web service ==")
     // console.log(user)
        this.httpService.getResponse('/menuroute/assignmenu',user).then(assignmenus=>{
          console.log("res")
          console.log(assignmenus) 
        }).catch(err=>{
          console.log(err);
        })
    }

 
  getUsers(){
  	
  	this.nodes=[];
  	Promise.all([this.httpService.getResponse('/menuroute/allMenu',this.model),this.httpService.getResponse('/menuroute/getappuser',this.model)]).then(([menus,userdata])=>{
      this.appMenus=menus.json();
     // console.log(this.appMenus);
      this.appMenus = this.appMenus.data;
     // console.log(this.appMenus.data);
      //console.log("=================");

      //console.log(this.appMenus)
      //console.log("=================");
      this.nodes=this.appMenus;
      //console.log(this.nodes);
      this.appusers = userdata.json();
      this.appusers =this.appusers.users;
  	}).catch(([menuErr,userdataErr])=>{
  		console.log(menuErr)
      console.log(userdataErr)
  	})
  }
 /* getChildren(node: any) {
    const newNodes = [
      {
        name: 'child1'
      }, {
        name: 'child2'
      }
    ];

    return new Promise((resolve, reject) => {
      setTimeout(() => resolve(newNodes), 1000);
    });
  }*/
  
  check(node, checked) {
      this.updateChildNodeCheckbox(node, checked);
      this.updateParentNodeCheckbox(node.realParent);

    }
    updateChildNodeCheckbox(node, checked) {
     
   
      //console.log(node.data);
       node.data.checked = checked;
      
      if(node.data.parent_id == "0")
        this.parentMenu.indexOf(node.data._id) === -1 ? this.parentMenu.push(node.data._id):"";

      if(node.data.checked && node.data.parent_id != 0){
           this.childMenu.push(node.data._id);
      }else{
           this.childMenu = this.childMenu.filter(e => e !== node.data._id);
      }
      console.log("child menu");
      console.log(this.childMenu);
      console.log("Parent Menu");
      console.log(this.parentMenu);
      if (node.children) {
        node.children.forEach((child) => {
          this.updateChildNodeCheckbox(child, checked)
          
        });
      }
  }


  updateParentNodeCheckbox(node) {
    if (!node) {

      return;
    }

   

    console.log("=====End=======");

    let allChildrenChecked = true;
    let noChildChecked = true;

    for (const child of node.children) {
      if (!child.data.checked || child.data.indeterminate) {
        allChildrenChecked = false;
      }
      if (child.data.checked) {
        noChildChecked = false;
      }
    }

    if (allChildrenChecked) {
      node.data.checked = true;
      node.data.indeterminate = false;
    } else if (noChildChecked) {
      node.data.checked = false;
      node.data.indeterminate = false;
    } else {
      node.data.checked = true;
      node.data.indeterminate = true;
      

    }
      var _id = node.data._id
      console.log(node.data);
     if (typeof _id != "undefined"){
          if(node.data.checked)
            this.parentMenu.indexOf(node.data._id) === -1 ? this.parentMenu.push(node.data._id):"";
          else
            this.parentMenu = this.parentMenu.filter(e => e !== node.data._id);
      }
    this.updateParentNodeCheckbox(node.parent);
  }
}



// WEBPACK FOOTER //
// ./src/app/assignmenu/assignmenu.component.ts